export default
`
<svg height="20px" width="14px" viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg" fill="#5f6368">
<path d="M16 1V5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V1H16Z" fill="currentColor"/>
</svg>
`;